export const downloadFileFromUrl = async (url: string, fileName: string, format: string) => {
  if (typeof window !== "undefined") {
    const res = await fetch(url, { method: "get" });
    const blob = await res.blob();
    const aElement = document.createElement("a");
    aElement.setAttribute("download", [fileName, format.replace(/^\./, "")].join("."));
    const href = URL.createObjectURL(blob);
    aElement.href = href;
    aElement.setAttribute("target", "_blank");
    aElement.click();
    URL.revokeObjectURL(href);
  }
};
